import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const Brands = () => {
    return (
        <div className="brands-wrapper xmt-10 xmt-lg-20">
            <div className="container">
                <div className="title">
                    <div className="title-box just-text title-box-blue">
                        <div className="title-bg">
                                <h2 className="text">
                                    برند ها
                                </h2>
                        </div>
                        <div className="more">
                            <span className="d-none d-sm-inline"><Link to="/brandPage">بیشتر</Link></span>
                            <Link to="/brandPage"><IconName name="chevron_left" className="icon"/></Link>
                        </div>
                    </div>
                </div>
                <div className="brands-slider">
                    <div className="top-brands-slider">
                        <div className="swiper brads-swiper xpt-6">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#F4F4F5"}}>
                                        <img src="./assets/sample-image/path-1.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#DBEBFD"}}>
                                        <img src="./assets/sample-image/Google_2015_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFEBEA"}}>
                                        <img src="./assets/sample-image/layer1.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFFAE5"}}>
                                        <img src="./assets/sample-image/layer-5.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#DBEBFD"}}>
                                        <img src="./assets/sample-image/ASUS_Logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFE9ED"}}>
                                        <img src="./assets/sample-image/LG_logo_(2015).png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFF4E5"}}>
                                        <img src="./assets/sample-image/g2993.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#EAF9EE"}}>
                                        <img src="./assets/sample-image/RAVpower_student_discount_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#DBEBFD"}}>
                                        <img src="./assets/sample-image/ASUS_Logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#DBEBFD"}}>
                                        <img src="./assets/sample-image/Google_2015_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bottom-brands-slider">
                        <div className="swiper brads-swiper xpt-4">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#DBEBFD"}}>
                                        <img src="./assets/sample-image/Samsung_Logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFF4E5"}}>
                                        <img src="./assets/sample-image/Group 2778.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#F4F4F5"}}>
                                        <img src="./assets/sample-image/path-2.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#EAF9EE"}}>
                                        <img src="./assets/sample-image/seagate-seeklogo.com.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFEBEA"}}>
                                        <img src="./assets/sample-image/OnePlus_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#EEFAFF"}}>
                                        <img src="./assets/sample-image/HP_New_Logo_2D.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#F4F4F5"}}>
                                        <img src="./assets/sample-image/g3.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#EAF9EE"}}>
                                        <img src="./assets/sample-image/RAVpower_student_discount_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFEBEA"}}>
                                        <img src="./assets/sample-image/OnePlus_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                                <div className="swiper-slide">
                                    <div className="brand-box" style={{background:"#FFEBEA"}}>
                                        <img src="./assets/sample-image/OnePlus_logo.png"  alt="apple"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brands;
